import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { AlertCircle } from 'lucide-react';

function NotFound() {
  const location = useLocation();
  const isAdminPath = location.pathname.startsWith("/admin");

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: isAdminPath ? '60vh' : '80vh',
      padding: '40px 20px',
      textAlign: 'center',
      color: isAdminPath ? 'var(--text-primary)' : '#1e293b'
    }}>
      <AlertCircle size={64} color={isAdminPath ? 'var(--primary)' : '#ef4444'} style={{ marginBottom: '20px' }} />
      <h1 style={{ fontSize: '4rem', fontWeight: 800, margin: '0 0 10px 0', lineHeight: 1 }}>404</h1>
      <h2 style={{ fontSize: '1.5rem', fontWeight: 600, margin: '0 0 15px 0' }}>Page Not Found</h2>
      <p style={{ maxWidth: '400px', margin: '0 0 30px 0', color: isAdminPath ? 'var(--text-secondary)' : '#64748b' }}>
        The page <strong>{location.pathname}</strong> does not exist or has been moved.
      </p>
      
      <Link 
        to="/" 
        style={{
          display: 'inline-block',
          padding: '12px 24px',
          background: isAdminPath ? 'linear-gradient(135deg, var(--primary), var(--primary-end))' : '#3b82f6',
          color: 'white',
          borderRadius: '8px',
          textDecoration: 'none',
          fontWeight: 600,
          boxShadow: '0 4px 14px rgba(0,0,0,0.15)',
          transition: 'transform 0.2s, opacity 0.2s'
        }}
        onMouseEnter={(e) => e.currentTarget.style.opacity = '0.9'}
        onMouseLeave={(e) => e.currentTarget.style.opacity = '1'}
      >
        Return to Home
      </Link>
    </div>
  );
}

export default NotFound;
